import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CommonService } from 'src/app/shared/services/common.service';
import { BaseFormGroup } from 'src/app/shared/form-input-components/base-form-group';
import { startWith, pairwise } from 'rxjs/operators';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-send-invoice',
  templateUrl: './send-invoice.component.html',
  styleUrls: ['./send-invoice.component.scss']
})
export class SendInvoiceComponent extends BaseFormGroup implements OnInit {

  @Input() bookings: any[];
  @Output() closeCallback = new EventEmitter();
  @Output() sendCallback = new EventEmitter();
  selectedItemLength: any = 0;


  public recipientType = [
    {dropdownLabel: 'Employee', value: 'employee'},
    // {dropdownLabel: 'Transport Manager', value: 'transportManager', label: 'Transport Manager'},
    {dropdownLabel: 'Approving Manager', value: 'approvingManager'}
  ];

  private employees: any[];
  public formDetails: FormGroup;
  public templates: any = {};
  public selectedMessage: any;
  public config: any;
  public approvingManagers: any[];
  private employeePersonIdMap: any = {};
  showError = false;

  constructor(private authService: AuthService, private commonService: CommonService, private changeDetectorRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {
    this.commonService.fetchConfig().subscribe((response) => {
      const popupConfig = this.commonService.getConfigForElementKey(response, 'Send Invoice Pop-up');
      this.config = {
        employee: this.commonService.getConfigForElementKey(popupConfig, 'Riders'),
        transportManager: this.commonService.getConfigForElementKey(popupConfig, 'Transport Manager'),
        approvingManager: this.commonService.getConfigForElementKey(popupConfig, 'Approving Manager'),
      };
    });
    this.extractUsersFromBookings();
    this.setupForm();
    this.changeDetectorRef.detectChanges();
  }
  getItemLength(value){
    this.selectedItemLength = value;
  }
  setupForm() {
    const employeeEmail = this.employees.map(emp => emp.email);
    this.formDetails =  new FormGroup({
      comment: new FormControl('', Validators.required),
      recipientType: new FormControl('employee', Validators.required),
      employee: new FormControl({value: employeeEmail, disabled: true}, this.checkEntries.bind(this, 'employee')),
      approvingManager: new FormControl({value: [], disabled: true}, this.checkEntries.bind(this, 'approvingManager'))
    });
    this.formDetails.get('employee').enable();
    this.formDetails.get('recipientType').valueChanges.pipe(startWith('employee'), pairwise()).subscribe(this.handleRecipientTypeChange);
  }

  handleRecipientTypeChange = ([prev, next]) => {
    if (prev && this.formDetails.get(prev)) {
      this.formDetails.get(prev).setValue([]);
      this.formDetails.get(prev).markAsPristine();
      this.formDetails.get(prev).disable();
    }

    if (this.formDetails.get(next)) {
      if (next === 'employee') {
        const employeeEmail = this.employees.map(emp => emp.email);
        this.formDetails.get(next).setValue(employeeEmail);
        this.employees.forEach((element) => {
          element.selected = true;
        });
      } else if (next === 'approvingManager') {
        const vendorIds = this.approvingManagers.map(vendor => vendor.guid);
        this.formDetails.get(next).setValue(vendorIds);
        this.approvingManagers.forEach((element) => {
          element.selected = true;
        });
      }
      this.formDetails.get(next).enable();
    }
  }

  checkEntries = (type: string, control: FormControl) => {
    if (this.formDetails.get('recipientType').value === type) {
      if (!control.value.length) {
        return {
          required: true
        };
      }
    }
    return null;
  }

  getOptions(type: string) {
    if (type === 'employee') {
      return this.employees;
    } else if (type === 'approvingManager') {
      return this.approvingManagers;
    }
  }

  extractUsersFromBookings() {
    const employeesMap = {};
    const transportManagersMap = {};
    const approvingManagersMap = {};
    for (const booking of this.bookings) {
      if (booking.tManagerName && booking.tManagerEmail && !transportManagersMap[booking.tManagerEmail]) {
        transportManagersMap[booking.tManagerEmail] = {name: booking.tManagerName,  email: booking.tManagerEmail};
      }
      if (booking.approvingManagerName && booking.approvingManagersMap && !approvingManagersMap[booking.approvingManagerEmail]) {
        approvingManagersMap[booking.tManagerEmail] = {name: booking.approvingManagerName,  email: booking.approvingManagerEmail};
      }
      for (const stop of booking.stops) {
        for (const rider of stop.riders) {
          if (!employeesMap[rider.email]) {
            employeesMap[rider.email] = rider;
            this.employeePersonIdMap[rider.email] = {[rider.personId]: true};
          }
          if (this.employeePersonIdMap) {
            this.employeePersonIdMap[rider.email][rider.personId] = true;
          }
        }
      }
    }

    this.employees = Object.values(employeesMap);
    this.approvingManagers = Object.values(approvingManagersMap);
  }

  onRecipientChange = (value: string) => {
    this.formDetails.get('recipientType').setValue(value);
  }

  getUniqueKeys() {
    const recipientType = this.formDetails.get('recipientType').value;
    if (recipientType === 'employee') {
      const empEmails = this.formDetails.get('employee').value;
      let personIdArr = [];
      empEmails.forEach((email) => {
        personIdArr = personIdArr.concat(Object.keys(this.employeePersonIdMap[email]));
      });
      return personIdArr;
    } else if (recipientType === 'approvingManager') {
      return this.formDetails.get('approvingManager').value;
    }
  }

  onSubmitClick = () => {
    if (this.formDetails.value.comment == '') { this.showError = true; }
    else if (!this.formDetails.valid) { this.markFormGroupDirty(this.formDetails); }
    else {
      this.showError = false;
      const request = {
        bookingIDs: this.bookings.map(booking => booking.bookingId),
        recipientType: this.formDetails.get('recipientType').value,
        comment: this.formDetails.get('comment').value,
        recipients: this.getUniqueKeys(),
        client: this.authService.client.client,
        buId: this.authService.user.buId,
        guId: this.authService.user.employeeGuid,
      };
      this.sendCallback.emit(request);
    }
  }

  getOptionValue = (option) => {
    return option.guid || option.email;
  }

  getOptionLabel = (option) => {
    return option.name || option.vendorName || option.driverName;
  }

  cancelCallback = () => {
    this.closeCallback.emit();
  }
}
